module.exports = __webpack_public_path__ + "img/particleIcon.e96e6b1f.png";